.root {
  display: inline-flex;
  padding: 4px;
  border-radius: 8px;
  background: var(
    --chartv2-selector-background,
    var(--surface-default, rgba(255, 255, 255, 4%))
  );
  gap: 4px;
}
